import { evalAuthHeaders, getEvalBase } from '../evalApiBase'
import { GoldenPrompt, GoldenPromptCreate } from './goldenPromptsModel'

type GoldenPromptListResponse = {
  items: GoldenPrompt[]
  limit: number
  offset: number
  total: number
}

const PAGE_SIZE = 50

export async function listGoldenPrompts(userId: string): Promise<GoldenPrompt[]> {
  const items: GoldenPrompt[] = []
  let offset = 0
  // The eval API caps `limit` at 50 per page, so we page through until we've
  // collected every row for this rater. Filtering down to the current session
  // happens client-side in goldenPromptsModel.findGoldenPromptForUserMessage.
  for (;;) {
    const query = new URLSearchParams({
      user_id: userId,
      limit: String(PAGE_SIZE),
      offset: String(offset),
    })
    const res = await fetch(`${getEvalBase()}/v1/golden-prompts?${query}`, {
      headers: evalAuthHeaders(),
    })
    if (!res.ok) {
      throw new Error(`Golden prompts list failed: ${res.status}`)
    }
    const body: GoldenPromptListResponse = await res.json()
    items.push(...body.items)
    if (items.length >= body.total || body.items.length === 0) {
      return items
    }
    offset += body.items.length
  }
}

export async function createGoldenPrompt(input: GoldenPromptCreate): Promise<GoldenPrompt> {
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts`, {
    method: 'POST',
    headers: { ...evalAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
  if (!res.ok) {
    throw new Error(`Golden prompt create failed: ${res.status}`)
  }
  return res.json()
}

export async function deleteGoldenPrompt(promptId: string): Promise<void> {
  const res = await fetch(`${getEvalBase()}/v1/golden-prompts/${promptId}`, {
    method: 'DELETE',
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Golden prompt delete failed: ${res.status}`)
  }
}
